/*
 * @Author: Src
 * @Date: 2025-06-30 16:53:28
 * @LastEditTime: 2025-10-16 20:23:11
 * @LastEditors: Src
 * @FilePath: /work-station/src/router/orderRoutes.ts
 * @Description: 头部注释配置模板
 */
import { RouteConfig } from 'vue-router';
import Main from '@/views/Main.vue';
import BOrderList from '@/views/order/BOrderList.vue';
import CorderList from '@/views/order/COrderList.vue';
import COrderStat from '@/views/order/COrderStat.vue';
import BRefundList from '@/views/order/BRefundList.vue';
import PaymentVoucherManagement from '@/views/order/PaymentVoucherManagement.vue';
import AutomaticSettlementlist from '@/views/order/AutomaticSettlementlist.vue';

import { AuthEnum } from '@/services/permission.service';

const shopRoutes: RouteConfig = {
  name: 'main.order',
  path: '/order',
  component: Main,
  redirect: {
    name: 'main.order.list.b',
  },
  meta: {
    title: '订单管理',
  },
  children: [
    {
      name: 'main.order.list.b',
      path: '/order/orderlist_b',
      component: BOrderList,
      props: {
        auth: [AuthEnum.B端订单列表],
      },
      meta: { title: 'B端订单列表' },
    },
    {
      name: 'main.order.list.b.notpay',
      path: '/order/orderlist_b_notpay',
      component: BOrderList,
      props: {
        auth: [AuthEnum.B端订单列表],
      },
      meta: { title: 'B端订单列表' },
    },
    {
      name: 'main.order.list.c',
      path: '/order/orderlist_c',
      component: CorderList,
      props: {
        auth: [AuthEnum.C端订单列表],
      },
      meta: { title: 'C端订单列表' },
    },
    {
      name: 'main.order.stat.c',
      path: '/order/orderstat_c',
      component: COrderStat,
      props: {
        auth: [AuthEnum.C端订单列表],
      },
      meta: { title: 'C端订单统计' },
    },
    {
      name: 'main.order.refund.b',
      path: '/order/refund_b',
      component: BRefundList,
      props: {
        auth: [AuthEnum.退单列表],
      },
      meta: { title: 'B端退单列表' },
    },
    {
      name: 'main.order.settlement',
      path: '/order/settlement',
      component: AutomaticSettlementlist,
      props: {
        auth: [AuthEnum.订单自动结算明细],
      },
      meta: { title: '自动结算列表' },
    },
    {
      name: 'main.order.paymentvoucher',
      path: '/order/paymentvoucher',
      component: PaymentVoucherManagement,
      props: {
        auth: [AuthEnum.收款凭证管理],
      },
      meta: { title: '收款凭证管理' },
    },
  ],
};

export default shopRoutes;
